import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ActivatedRoute } from "@angular/router";
import { Helpers } from "src/app/services/app.helpers";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-community-layout",
  templateUrl: "./community-layout.component.html",
  styleUrls: ["./community-layout.component.scss"]
})
export class CommunityLayoutComponent implements OnInit {
  myProfile: any;
  community: any;
  environmentVars: any;
  constructor(
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private helpers: Helpers
  ) { }

  ngOnInit() {
    this.environmentVars = environment;
    this.myProfile = this.authService.getLocalProfile();
    this.route.data.subscribe(response => {
      this.helpers.fixCommunityCoverImages(response.community[1].userCommunity);
      this.community = response.community[1].userCommunity;
    });
  }

}
